module.exports = __webpack_public_path__ + "static/4-0952d38c83850d0e963efbe50f94aa75.jpg";